import React from 'react';

import { useCurrentAgencyUser } from '~/components/current-user';
import type { FilterViewer } from '~/api/data/filter-base';

/**
 * Memoised `{ userId, teamIds }` for the signed-in agency user, in the shape
 * required by the client-side visibility/sharedWithMe/team filter matchers.
 * Centralises what used to be a per-page React.useMemo so library pages stay
 * focused on rendering.
 */
export function useCurrentViewer(): FilterViewer {
  const agencyUser = useCurrentAgencyUser();
  return React.useMemo(
    () => ({ userId: agencyUser.id, teamIds: agencyUser.teams.map((t) => t.id) }),
    [agencyUser.id, agencyUser.teams]
  );
}
